import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterV3Component } from './filter-v3.component';
import {
  GooglePlacesLocationModule
} from "../../lib/google-places-location/google-places-location/google-places-location.module";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import {
  ButtonModule,
  DropdownModule,
  InputsModule,
  ToggleModule
} from '@xref/xref-lib';
import {PlacesService} from "../../services/places/places.service";
import {
  DateRangePickerPopoverV2Module
} from "../../lib/app-date-range-picker-popover-v2/date-range-picker-popover-v2.module";
import {FormsModule} from "@angular/forms";


@NgModule({
  declarations: [FilterV3Component],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    InputsModule,
    DropdownModule,
    ButtonModule,
    ToggleModule,
    DateRangePickerPopoverV2Module,
    GooglePlacesLocationModule,
    FormsModule
  ],
  providers:[PlacesService],
  exports: [FilterV3Component]
})
export class FilterV3Module { }
